'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CountdownTimer = exports.nextMidnight = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var nextMidnight = exports.nextMidnight = function nextMidnight() {
  var midnight = new Date();
  midnight.setHours(24, 0, 0, 0);
  return midnight;
};

var CountdownTimer = exports.CountdownTimer = function (_Component) {
  (0, _inherits3.default)(CountdownTimer, _Component);

  function CountdownTimer(props) {
    (0, _classCallCheck3.default)(this, CountdownTimer);

    var _this = (0, _possibleConstructorReturn3.default)(this, (CountdownTimer.__proto__ || (0, _getPrototypeOf2.default)(CountdownTimer)).call(this, props));

    var countdownTo = props.countdownTo;

    var now = Date.now();
    var countdownTime = countdownTo - now;

    _this.updateTimer = _this.updateTimer.bind(_this);
    _this.state = {
      countdownTime: Math.max(countdownTime, 0)
    };
    return _this;
  }

  (0, _createClass3.default)(CountdownTimer, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.timer = setInterval(this.updateTimer, 1000);
      this.intervalStartTime = Date.now();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearInterval(this.timer);
    }
  }, {
    key: 'updateTimer',
    value: function updateTimer() {
      var distance = Date.now() - this.intervalStartTime;
      var updatedCountdownTime = this.state.countdownTime - distance;
      if (updatedCountdownTime >= 0) {
        this.setState({ countdownTime: updatedCountdownTime });
        this.intervalStartTime = Date.now();
      } else {
        this.setState({ countdownTime: 0 });
        clearInterval(this.timer);
      }
    }
  }, {
    key: 'calculateTime',
    value: function calculateTime() {
      var countdownTime = this.state.countdownTime;
      // Time calculations for hours, minutes and seconds

      return {
        hours: Math.floor(countdownTime % (1000 * 60 * 60 * 24) / (1000 * 60 * 60)),
        minutes: Math.floor(countdownTime % (1000 * 60 * 60) / (1000 * 60)),
        seconds: Math.floor(countdownTime % (1000 * 60) / 1000)
      };
    }
  }, {
    key: 'render',
    value: function render() {
      var _calculateTime = this.calculateTime(),
          hours = _calculateTime.hours,
          minutes = _calculateTime.minutes,
          seconds = _calculateTime.seconds;

      return _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'count.down.timer',
        defaultMessage: '{hours}h {minutes}m {seconds}s',
        values: {
          hours: hours,
          minutes: minutes,
          seconds: seconds
        }
      });
    }
  }]);
  return CountdownTimer;
}(_react.Component);

CountdownTimer.propTypes = {
  countdownTo: _propTypes2.default.number.isRequired
};